<template>
  <v-row no-gutters style="height: 100%">
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12" class="mt-4">
          <v-row no-gutters>
            <v-col cols="12" class="mt-2">
              <span class="body-2">
                {{ $t('message.pages.drm.advancedTab') }}
              </span>
            </v-col>
            <v-col cols="12" class="mt-4">
              <v-row no-gutters align="center">
                <v-icon
                  :color="group.active ? 'primary' : 'grey'"
                  class="pb-1 mr-2"
                  size="20"
                >
                  {{ group.active ? 'mdi-lock' : 'mdi-lock-open-variant' }}
                </v-icon>
                <span>
                  <b>
                    {{ $t('message.pages.drm.settings.videoSafety') }}
                  </b></span
                >
                <v-switch
                  v-model="group.active"
                  class="ml-4 mt-0 pt-0"
                  dense
                  hide-details
                ></v-switch>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mb-2 mt-4" v-if="hasChangedValue">
          <span>
            <b>
              {{ $t('message.pages.drm.settings.confirmPassword') }}
            </b>
          </span>
        </v-col>
        <v-col cols="12" v-if="hasChangedValue">
          <v-text-field
            v-model="password"
            class="pr-2"
            :label="$t('message.password')"
            dense
            outlined
            autofocus
            autocomplete="off"
            :error="errors.invalidAccountError"
            :messages="passwordErrorMsg"
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPass ? 'text' : 'password'"
            @click:append="showPass = !showPass"
          >
            <template v-slot:message="{ message }">
              <span
                class="red--text caption align-text"
                v-if="errors.invalidAccountError"
              >
                <v-icon color="red" size="18" class="pb-1">
                  mdi-alert-circle
                </v-icon>
                {{ message }}
              </span>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="d-flex justify-end align-end pb-6">
      <v-card width="100%" flat>
        <v-card-actions>
          <v-btn
            min-width="140px"
            text
            color="error"
            :disabled="
              isFetching || fetchingRemove || drmGroup.root || !hasEditDrmPerm
            "
            :loading="fetchingRemove"
            @click="handleRemoveGroup"
          >
            {{ $t('message.pages.drm.settings.removeGroup') }}
          </v-btn>
          <v-spacer />
          <v-btn
            min-width="140px"
            text
            class="mr-2"
            :disabled="isFetching"
            @click="handleCloseModal"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            min-width="140px"
            color="primary"
            :disabled="isFetching || !shouldBeAbleToPublish || !hasEditDrmPerm"
            :loading="isFetching"
            @click="handleUpdate"
          >
            <span class="mx-2"> {{ $t('message.actions.save') }} </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'
import { mapActions, mapMutations } from 'vuex'
import i18n from '@/translations/lang'

export default {
  name: 'DrmAdvanced',
  components: {},
  props: {
    drmGroup: Object,
    handleCloseModal: Function,
  },
  data: () => ({
    isFetching: false,
    groupId: '',
    startingActiveValue: false,
    group: {
      active: false,
    },
    showPass: false,
    password: '',
    errors: {
      invalidAccountError: false,
      unexpectedError: false,
      internalErrorException: false,
      removeError: false,
    },
    errMsg: {
      removeErrorMsg: '',
    },
    unknownError: '',
    fetchingRemove: false,
  }),
  computed: {
    hasEditDrmPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-watermark') ??
        false
      )
    },
    passwordErrorMsg() {
      if (this.errors.invalidAccountError) {
        return i18n.t(
          'message.pages.video.deleteModal.errors.invalidAccountError'
        )
      }
      if (this.errors.internalErrorException) {
        return i18n.t('message.pages.video.deleteModal.errors.internalError')
      }
      if (this.errors.unexpectedError) {
        return i18n.t('message.errors.unexpectedError') + this.unknownError
      }
      return ''
    },
    hasChangedValue() {
      return this.group.active !== this.startingActiveValue
    },
    userInfo() {
      return this.$store.getters['session/userAttributes']
    },
    shouldBeAbleToPublish() {
      return this.hasChangedValue && this.password.length > 5
    },
  },
  watch: {
    drmGroup: {
      immediate: true,
      handler(val) {
        this.groupId = val.id
        this.group.active = val.active
        this.startingActiveValue = val.active
      },
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
    ]),
    ...mapActions('session', ['signInUser']),
    async handleRemoveGroup() {
      this.fetchingRemove = true
      try {
        let ret = await drmApi.deleteDrmGroup(this.drmGroup.id)
        this.$root.$emit('removeDrmGroup', this.drmGroup)
        this.handleCloseModal()
        this.fetchingRemove = false
        console.log('drm delete', ret)
      } catch (e) {
        this.fetchingRemove = false
        console.log('e', e)
      }
    },
    async handleUpdate() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      this.password = this.password.trim()
      let groupObject = {
        active: this.group.active,
      }
      this.isFetching = true
      let confirmResponse = await this.confirmUserPassword()
      if (!confirmResponse) return
      try {
        let ret = await drmApi.drmUpdateVideos(this.groupId, groupObject)
        this.isFetching = false
        this.startingActiveValue = ret.data.active
        this.$root.$emit('updateDrmGroup', ret.data)
        this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(true)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: 'Configurações salvas com sucesso!',
        })
        this.handleCloseModal()
      } catch (e) {
        this.isFetching = false
        console.log('e', e)
      }
    },
    async confirmUserPassword() {
      try {
        await this.signInUser({
          username: this.userInfo.email,
          password: this.password,
        })
        return true
      } catch (error) {
        this.isFetching = false
        if (!error.code) {
          const anyError = JSON.parse(JSON.stringify(error))
          if (anyError.message.includes('Network Error')) {
            this.changePasswordLoading = false
            this.unknownError = 'Code: 500'
            this.newPasswordError.newPasswordError = true
            return
          }
        }
        if (
          error.code === 'NotAuthorizedException' ||
          error.code === 'InvalidParameterException'
        ) {
          this.errors.invalidAccountError = true
        }
        if (error.code === 'InternalErrorException') {
          this.errors.internalErrorException = true
        }
        this.isFetching = false
        return false
      }
    },
  },
}
</script>

<style></style>
